<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref } from "vue";
import { errorAlert } from "../plugins/alert";
import TextBox from "./TextBox.vue";

const props = defineProps({
    searchWord: {
      type:String,
      required:true
    },
    onChange: {
      type:Function,
      required:true
    },
    onEnter: {
      type:Function,
      required:true
    },
    fontSize: {
      type:String,
      default: () => {
        return '';
      }
    },
    fontLineHeight: {
      type:String,
      default: () => {
        return '';
      }
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})

const { searchWord } = toRefs(props);
const searchText = ref(props.searchWord);
const wordChange = () => {
  props.onEnter(searchText.value);
}
const onChange = (value) => {
  searchText.value = value;
}
const onEnter = (value) => {
  searchText.value = value;
  props.onEnter(searchText.value);
}
const onClear = () => {
  searchText.value = '';
  props.onEnter(searchText.value);
}
watch(searchWord,(newValue, oldValue) => {
  searchText.value = newValue;
})

</script>

<style scoped lang='sass'>
</style>

<template>
  <div class="flex rounded-md shadow-sm w-full">
      <text-box
        :value="searchText"
        type="text"
        :font-size="fontSize"
        :font-line-height="fontLineHeight"
        :is-focus-clear="true"
        :is-no-rounded-right="true"
        :on-change="onChange"
        :on-enter="onEnter"
        :on-clear="onClear"
        :place-holder="placeHolder"
      ></text-box>
      <span @click="wordChange" class="cursor-pointer inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500"><i class="fa-solid fa-magnifying-glass"></i></span>
  </div>
</template>

